export default __webpack_public_path__ + "static/media/logo.e09db013.png";